import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/clients/teams/'
)({
  beforeLoad: () => {
    // Redirect to unified teams page
    throw redirect({ to: '/staff/teams' })
  },
})
